import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('main', ['allOptions']),
    trmOptions() {
      return [
        {
          id: '1',
          name: 'Third Party Only'
        }
      ]
    }
  },
  methods: {
    getAllOptionsName(target, id) {
      let result = ''
      this.allOptions[target].some(item => {
        // eslint-disable-next-line
        if (item.id == id) {
          result = item.name
          return true
        }
        return false
      })
      return result
    },
    getAllOptionsId(target, name) {
      let result = ''
      this.allOptions[target].some(item => {
        // eslint-disable-next-line
        if (item.name == name) {
          result = item.id
          return true
        }
        return false
      })
      return result
    },
  }
}